<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
===================test======================================================================= -->


<template>
	<div id="app" :class="vueAppClasses">
		<router-view @setAppClasses="setAppClasses" oncontextmenu="return false" />
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import jwt         from "@/http/requests/auth/jwt/index.js"

export default {
  data() {
    return {
      vueAppClasses: [],
    }
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    }
  },
  methods: {
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      }
      else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      }
      else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
			// console.log(document.documentElement.scrollTop)
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

  },
  async created() {
		this.$acl.change("superAdmin")
    // jwt
    let dir = this.$vs.rtl ? "rtl" : "ltr"
    document.documentElement.setAttribute("dir", dir)
    window.addEventListener('resize', this.handleWindowResize)
		document.addEventListener('scroll', this.handleScroll)
    if (window.innerWidth <= 599) {
      console.log(window.innerWidth)
      this.$store.commit("HANDLE_IS_MOBILE", true)
    } else {
      this.$store.commit("HANDLE_IS_MOBILE", false)
    }
    // Auth0
    // try       { await this.$auth.renewTokens() }
    // catch (e) { console.error(e) }
		jwt.init().then((resolve)=>{
			this.$store.commit('UPDATE_USER_INFO', resolve.data.userData)
			this.$acl.change( resolve.data.userData.userRole)
		}).catch((error) => {
			console.log(error)
		})
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    // window.removeEventListener('scroll', this.handleScroll)

  },
}

</script>
<style>
  * {
    touch-action: pan-x pan-y;
  }
  img {
    -webkit-touch-callout: none
  }
</style>
